<template>
    <a-modal :title="title" width="1200px" :maskClosable="false" :visible.sync="show" @cancel="() => $emit('update:show', false)" :footer="null" :getContainer="() => $parent.$el">
        <div v-if="cur >= 0">
            <!-- <a-alert :show-icon="false" banner>
                <div slot="message">{{ detail.name }} [ {{ detail.type | raceType }} / {{ (detail.type + '_' + detail.level) | raceLevel }} ] 共 {{ detail.uds.length }} 人参赛</div>
            </a-alert> -->

            <div style="margin-right: auto; margin-left: auto;text-align: center;">
                <a-button size="small" :disabled="cur >= dss.length - 1" @click="toPrev">
                    <a-icon type="left" />
                    上一次记录
                </a-button>
                <span style="font-size:1.4em; margin-left: 50px; margin-right: 50px;">编号：[{{ dss[cur].id }}] 第 {{ dss.length - cur }} 次 / 共 {{ dss.length }} 次</span>
                <a-button size="small" :disabled="cur == 0" @click="toNext">
                    下一次记录
                    <a-icon type="right" />
                </a-button>
            </div>

            <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="rst" bordered :pagination="false">
                <a-table-column key="name" ellipsis width="150px">
                    <span slot="title">训练项目</span>
                    <template slot-scope="text, record">
                        <span>[{{ record.id }}] {{ record.name }}</span>
                    </template>
                </a-table-column>
                <a-table-column key="info" ellipsis width="100px">
                    <span slot="title">训练内容</span>
                    <template slot-scope="text, record">
                        <span>{{ record.info }}</span>
                    </template>
                </a-table-column>
                <a-table-column key="rdi" ellipsis>
                    <span slot="title">训练记录</span>
                    <template slot-scope="text, record">
                        <span>{{ record.rdi }}</span>
                    </template>
                </a-table-column>
                <a-table-column key="score" ellipsis width="100px">
                    <span slot="title">积分</span>
                    <template slot-scope="text, record">
                        <span>{{ record.score }}</span>
                    </template>
                </a-table-column>
            </a-table>
        </div>
    </a-modal>
</template>
<script>
import _ from 'lodash'
import moment from 'moment'

export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },

    data() {
        return {
            dss: [],
            rst: [],
            cur: -1
        }
    },
    mounted() {
        this.doLoadIndex()
    },
    methods: {
        doLoadIndex() {
            this.$http
                .get('/cts/ate/testing/mgr/user/data', {
                    params: {
                        tid: this.item.tuser.id,
                        type: 'Exer'
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.dss = result.datas
                    this.cur = this.dss.findIndex(s => s.id === this.item.id)
                    if (this.cur < 0) {
                        this.cur = 0
                    }
                    this.doLoadDetail(this.dss[this.cur].id)
                })
        },
        doLoadDetail(id) {
            this.rst = []
            this.$http
                .get('/cts/ate/testing/mgr/detail', {
                    params: {
                        id: id
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    let info = JSON.parse(result.data.info)
                    if (!info.records || info.records.length == 0) {
                        this.convertItem([])
                        return
                    }
                    let drs = _.sortBy(info.records, r => moment(r.day, 'YYYY-MM-DD').unix())
                    let last = drs[drs.length - 1]
                    this.convertItem(last.rs)
                })
        },
        toPrev() {
            if (this.cur >= this.dss.length - 1) {
                return
            }
            this.cur++
            this.doLoadDetail(this.dss[this.cur].id)
        },
        toNext() {
            if (this.cur == 0) {
                return
            }
            this.cur--
            this.doLoadDetail(this.dss[this.cur].id)
        },

        convertItem(rsItems) {
            let items = [
                { id: 1, name: '热身训练' },
                { id: 2, name: '舒尔特方格' },
                { id: 3, name: '虚实线' },
                { id: 4, name: '中心悬点' },
                { id: 5, name: '视记广度' },
                { id: 6, name: '听觉辨别' },
                { id: 7, name: '听记广度' },
                { id: 8, name: '图形划消' },
                { id: 9, name: '记忆编码' },
                { id: 10, name: '数独' },
                { id: 11, name: '牵引阅读' },
                { id: 12, name: '思维表达' }
            ]
            let rsArr = []
            for (let item of items) {
                let result = {
                    id: item.id,
                    name: item.name,
                    info: '--',
                    rdi: '--',
                    score: '--'
                }
                let rsItem = rsItems.find(r => r.id == item.id)
                if (!rsItem || !rsItem.rs || rsItem.length == 0) {
                    rsArr.push(result)
                    continue
                }
                result.info = rsItem.rs[0].desp
                result.score = rsItem.score
                switch (item.id) {
                    case 1: {
                        result.info = '猜拳'

                        let rs = _.sortBy(rsItem.rs, ['com', 'avg', 'fast'])
                        if (rs[0].fast && rs[0].slow) {
                            result.rdi = `结果：${rs[0].user}:${rs[0].com}，平均反应：${(rs[0].avg / 1000).toFixed(3)}，最快反应：${(rs[0].fast / 1000).toFixed(3)}，最慢反应：${(rs[0].slow / 1000).toFixed(3)}`
                        } else {
                            result.rdi = '无成绩'
                        }
                        break
                    }
                    case 2: {
                        result.info = `${rsItem.rs[0].level} * ${rsItem.rs[0].level}`

                        let rs = _.sortBy(rsItem.rs, ['fast'])
                        let fast
                        for (let index = 0; index < rs.length; index++) {
                            if (rs[index].fast) {
                                fast = rs[index]
                                break
                            }
                        }
                        if (fast) {
                            if (fast.slow) {
                                result.rdi = `最快：${(parseFloat(fast.fast) / 1000).toFixed(2)}秒，最慢：${(parseFloat(fast.slow) / 1000).toFixed(2)}秒`
                            } else {
                                result.rdi = `最快：${(parseFloat(fast.fast) / 1000).toFixed(2)}秒，最慢：${(parseFloat(fast.fast) / 1000).toFixed(2)}秒`
                            }
                        } else {
                            result.rdi = '未完成训练'
                        }
                        break
                    }

                    case 3: {
                        let rs = _.sortBy(rsItem.rs, ['avg'])
                        let tr = rs[rs.length - 1]
                        result.rdi = `最快：${(tr.fast / 1000).toFixed(2)}秒，最慢：${(tr.slow / 1000).toFixed(2)}秒，平均符合度：${tr.avg.toFixed(2)}%`
                        break
                    }
                    case 4: {
                        let rs = _.sortBy(rsItem.rs, ['avg'])
                        let tr = rs[rs.length - 1]
                        if (tr.fast && tr.slow) {
                            result.rdi = `最快：${(tr.fast / 1000).toFixed(2)}秒，最慢：${(tr.slow / 1000).toFixed(2)}秒，平均符合度：${tr.avg.toFixed(2)}%`
                        } else {
                            result.rdi = '未完成训练'
                        }
                        break
                    }
                    case 5: {
                        let hasRecord = false
                        let maxNum = 0
                        for (let r of rsItem.rs) {
                            if (r.record.length > 0) {
                                hasRecord = true
                                for (let sr of r.record) {
                                    if (sr.targetNum > maxNum) {
                                        maxNum = sr.targetNum
                                    }
                                }
                            }
                        }
                        if (hasRecord) {
                            result.rdi = `达到${maxNum}位`
                        } else {
                            result.rdi = '未完成训练'
                        }
                        break
                    }
                    case 6: {
                        let err = 0
                        let correct = 0
                        for (let r of rsItem.rs) {
                            err += r.totalCount - r.correctCount
                            correct += r.correctCount
                        }
                        result.rdi = `答对 ${correct} 次，答错 ${err} 次`
                        break
                    }
                    case 7: {
                        let err = 0
                        let correct = 0
                        for (let r of rsItem.rs) {
                            err += r.errCount
                            correct += r.correctCount
                        }
                        result.rdi = `答对 ${correct} 次，答错 ${err} 次`
                        break
                    }
                    case 8: {
                        let err = 0
                        let correct = 0
                        for (let r of rsItem.rs) {
                            for (let subr of r.record) {
                                if (subr.error === 0) {
                                    correct++
                                } else {
                                    err++
                                }
                            }
                        }
                        result.rdi = `答对 ${correct} 次，答错 ${err} 次`
                        break
                    }
                    case 9: {
                        let hasRecord = false
                        let maxNum = 0
                        for (let r of rsItem.rs) {
                            if (r.record.length > 0) {
                                hasRecord = true
                                for (let sr of r.record) {
                                    if (sr.num > maxNum) {
                                        maxNum = sr.num
                                    }
                                }
                            }
                        }
                        if (hasRecord) {
                            result.rdi = `达到${maxNum}格`
                        } else {
                            result.rdi = '未完成训练'
                        }
                        break
                    }
                    case 10: {
                        let err = 0
                        let correct = 0
                        for (let r of rsItem.rs) {
                            for (let subr of r.record) {
                                if (subr.correct) {
                                    correct++
                                } else {
                                    err++
                                }
                            }
                        }
                        result.rdi = `完成 ${correct} 格，未完成 ${err} 格`
                        break
                    }
                    case 11: {
                        result.rdi = `${rsItem.rs[0].val}`
                        break
                    }
                    case 12: {
                        result.rdi = `${rsItem.rs[rsItem.rs.length - 1].voice}`
                        break
                    }
                }

                rsArr.push(result)
            }
            this.rst = rsArr
        }
    }
}
</script>
